
import { mapMutations } from 'vuex';
import { RemoveToastNotification } from '@/constants/mutations';

export default {
  props: {
    toast: { type: Object, default: () => ({}) },
    toastStyle: { type: Object, default: () => ({}) },
    index: { type: Number, default: 0 },
  },

  methods: {
    ...mapMutations('notificationStore', {
      close: RemoveToastNotification,
    }),

    handleInput(opened) {
      if (!opened && this.toast.closable) {
        this.close(this.toast.id);
      }
    },

    handleAction({ onClick, closeOnClick }) {
      if (onClick) {
        onClick();
      }

      if (closeOnClick) {
        this.close(this.toast.id);
      }
    },
  },
};
